export default __webpack_public_path__ + "static/media/icon_cycling.c205d7a5.svg";